interface EnvironmentConfig {
    env: string;
    apiUrl: string;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
    // Default to development if no environment is specified
    const env = process.env.REACT_APP_ENV || "development";

    switch (env) {
        case "production":
            return {
                env: "production",
                apiUrl:
                    process.env.REACT_APP_API_URL ||
                    "https://jheprnczqex6srpgw4luw4siyi0uujkc.lambda-url.us-east-1.on.aws",
            };
        case "staging":
            return {
                env: "staging",
                apiUrl:
                    process.env.REACT_APP_API_URL ||
                    "api-staging.thegohrproject.com",
            };
        case "development":
        default:
            return {
                env: "development",
                apiUrl:
                    process.env.REACT_APP_API_URL || "http://localhost:3001",
            };
    }
};

export const config = getEnvironmentConfig();
export default config;
